/* Keeps --summary-height in sync with the sticky cart summary, so the scrollable drawer content
   gets enough bottom padding and nothing ends up hidden behind the checkout area.
   The theme only measures the summary while the drawer is still closed (height 0), so this re-measures. */
(function () {
  if (window.__bfSummaryHeight) return;
  window.__bfSummaryHeight = true;

  function sync() {
    var root = document.querySelector('cart-element.cart--root[data-view="drawer"]');
    var summary = root && root.querySelector('.cart--summary');
    if (!summary) return;
    var h = summary.offsetHeight;
    if (!h) return;
    var value = h + 'px';
    if (root.style.getPropertyValue('--summary-height') !== value) {
      root.style.setProperty('--summary-height', value);
    }
  }

  setInterval(sync, 300);
  ['theme:cart:updated', 'theme:cart:drawer:updateHtml', 'theme:drawer:open', 'resize'].forEach(function (name) {
    window.addEventListener(name, function () {
      setTimeout(sync, 80);
      setTimeout(sync, 500);
    });
  });
  sync();
})();